import FormConfig from "../formConfig.js";
import CaLock from "@/components/common/calock";
import {
  fun_PostAction,
  fun_GetAction,
  fun_Download,
  fun_UploadImg
} from "@/api/index";
import {fun_DownloadFile, fun_GetKeys} from "@/utils/validate";
import { Loading } from "element-ui";
import Pictureinfor from "../../../components/pictureinfor/index.vue";
import ModifyHistoryRecord from "../../components/modifyHistoryRecord/index.vue";
import AuditHistoryRecord from "../../../components/auditHistoryRecord/index.vue";
import ProjectChooseDialog from "../../../components/projectChooseDialog/index.vue";
import WinningPublicBackupDetail from "../components/winningPublicBackupDetail/index.vue";
export default {
  data() {
    return {
      detailSdialogVisible: true,
      // 流程状态
      stepsActive: 0,
      // 流程数据
      stepsList: [
        {
          name: "中标项目基本信息",
          isSave: false, // 是否保存
          isActive: true, // 是否可点击
          formList: FormConfig.projectInformation()
        },
        {
          name: "中标候选人信息",
          isSave: false,
          isActive: true,
          formList: FormConfig.winBidInformation()
        },
        {
          name: "开标记录信息",
          isSave: false,
          isActive: true,
          formList: FormConfig.bidOpeningRecordInformation()
        },
        {
          name: "其他信息",
          isSave: false,
          isActive: true,
          formList: FormConfig.otherInformation()
        }
      ],
      // 表单配置
      formConfigList: FormConfig.projectInformation(),
      // 表单绑定值
      form: {
        id: null,
        prjName: null, // 项目名称
        publicityStartDate: null, // 公示开始时间
        publicityEndDate: null, // 公示结束时间
        publicityDay: null, // 公示天数（天）
        regulators: null, // 招标监管部门
        reserveStartTime: null, // 开标时间
        openingPlace: null, // 开标地点
        evaluationStartDate: null, // 评标时间
        reviewAdd: null, // 评标地点
        tenderReference: null, // 招标编号
        section: null, // 标段号
        tenderCorp: null, // 建设单位（招标人）
        person: null, // 经办人
        personPhone: null, // 联系电话
        agencyCorp: null, // 招标代理机构
        agencyCorpPerson: null, // 经办人
        agencyCorpPhone: null, // 联系电话
        constructionPrjName: null, // 报建项目名称
        constructionNo: null, // 报建编号
        tenderTypeName: null, // 招标方式
        tenderClassName: null, // 招标类别
        tenderContent: null, // 招标内容
        dissentDepartmentName: null, // 异议受理部门名称
        dissentDepartmentAddress: null, // 异议受理部门地址
        dissentDepartmentLinkMan: null, // 异议受理部门联系人
        dissentDepartmentLink: null, // 异议受理部门联系人手机
        dissentPostalCode: null, // 异议受理部门邮政编码
        dissentDepartmentEmail: null, // 异议受理部门电子邮箱
        supervisionDept: null, // 行政监督部门名称
        supervisionDeptAddress: null, // 行政监督部门地址
        supervisionDeptLinkMan: null, // 行政监督部门联系人
        supervisionDeptLinkPhone: null, // 行政监督部门电话
        tradingCenter: null, // 公共资源交易综合监管机构名称
        tradingCenterAddress: null, // 公共资源交易综合监管机构地址
        tradingCenterLinkMan: null, // 公共资源交易综合监管机构联系人
        tradingCenterLinkPhone: null, // 公共资源交易综合监管机构电话
        structureArea: null, // 房屋建筑工程面积
        highFloor: null, // 结构层次
        upFloor: null, // 地上
        underFloor: null, // 地下
        prjAddress: null, // 建设地址
        prjSize: null, // 建设规模
        tenderScope: null, // 招标范围
        tenderScopeUpdate: null, // 招标范围修改原因
        regTenderContent: null, // 登记中的招标内容
        remarksMonomer: null, // 备注(注明单体工程名称、栋号)
        publicState: null, // 公示状态
        revocationReason: null, // 撤回原因
        revocationNum: null, // 撤回次数
        isNeedPm: null, // 是否需要项目负责人/总监
        isNeedPmName: null, // 是否需要项目负责人/总监
        bulletinDuty: null, // 公示发布责任人
        isPerformanceBondAmount: null, // 是否有履约保证金
        performanceBondAmount: null, // 履约保证金（元）
        isProjectQualityDeposit: null, // 是否有工程质量保证金
        projectQualityDeposit: null, // 工程质量保证金（元）
        openType: null, // 公开类型
        bidOpeningAddress: null, // 开标地点
        bidOpeningTime: null, // 开标时间
        bidOpeningActor: null, // 开标参与人
        doubleOpenType: null, // 第二信封公开类型
        doubleBidOpeningAddress: null, // 第二信封开标地点
        doubleBidOpeningTime: null, // 第二信封开标时间
        doubleBidOpeningActor: null, // 第二信封开标参与人
        remarks: null, // 备注
        bidOpeningContent: null, // 开标内容
        doubleBidOpeningContent: null, // 第二信封开标内容
        tenderOpinion: null, // 招标人意见
        evaluationMethod: null, // 评标办法
        tenderBondFlag: null, // 保证金标志
        totalInvestment: null, // 批准投资总额
        isAudit: null, // 是否核验
        tenderContentNum: null, // 招标内容
        ebsFlag: null, // 电子标标识
        state: null // 状态
      },
      errRules: {
        id: null,
        prjName: null, // 项目名称
        publicityStartDate: null, // 公示开始时间
        publicityEndDate: null, // 公示结束时间
        publicityDay: null, // 公示天数（天）
        regulators: null, // 招标监管部门
        reserveStartTime: null, // 开标时间
        openingPlace: null, // 开标地点
        evaluationStartDate: null, // 评标时间
        reviewAdd: null, // 评标地点
        tenderReference: null, // 招标编号
        section: null, // 标段号
        tenderCorp: null, // 建设单位（招标人）
        person: null, // 经办人
        personPhone: null, // 联系电话
        agencyCorp: null, // 招标代理机构
        agencyCorpPerson: null, // 经办人
        agencyCorpPhone: null, // 联系电话
        constructionPrjName: null, // 报建项目名称
        constructionNo: null, // 报建编号
        tenderTypeName: null, // 招标方式
        tenderClassName: null, // 招标类别
        tenderContent: null, // 招标内容
        dissentDepartmentName: null, // 异议受理部门名称
        dissentDepartmentAddress: null, // 异议受理部门地址
        dissentDepartmentLinkMan: null, // 异议受理部门联系人
        dissentDepartmentLink: null, // 异议受理部门联系人手机
        dissentPostalCode: null, // 异议受理部门邮政编码
        dissentDepartmentEmail: null, // 异议受理部门电子邮箱
        supervisionDept: null, // 行政监督部门名称
        supervisionDeptAddress: null, // 行政监督部门地址
        supervisionDeptLinkMan: null, // 行政监督部门联系人
        supervisionDeptLinkPhone: null, // 行政监督部门电话
        tradingCenter: null, // 公共资源交易综合监管机构名称
        tradingCenterAddress: null, // 公共资源交易综合监管机构地址
        tradingCenterLinkMan: null, // 公共资源交易综合监管机构联系人
        tradingCenterLinkPhone: null, // 公共资源交易综合监管机构电话
        structureArea: null, // 房屋建筑工程面积
        highFloor: null, // 结构层次
        upFloor: null, // 地上
        underFloor: null, // 地下
        prjAddress: null, // 建设地址
        prjSize: null, // 建设规模
        tenderScope: null, // 招标范围
        tenderScopeUpdate: null, // 招标范围修改原因
        regTenderContent: null, // 登记中的招标内容
        remarksMonomer: null, // 备注(注明单体工程名称、栋号)
        revocationReason: null, // 撤回原因
        isNeedPm: null, // 是否需要项目负责人/总监
        isNeedPmName: null, // 是否需要项目负责人/总监
        bulletinDuty: null, // 公示发布责任人
        performanceBondAmount: null, // 履约保证金（元）
        isProjectQualityDeposit: null, // 是否有工程质量保证金
        projectQualityDeposit: null, // 工程质量保证金（元）
        openType: null, // 公开类型
        bidOpeningAddress: null, // 开标地点
        bidOpeningTime: null, // 开标时间
        bidOpeningActor: null, // 开标参与人
        doubleOpenType: null, // 第二信封公开类型
        doubleBidOpeningAddress: null, // 第二信封开标地点
        doubleBidOpeningTime: null, // 第二信封开标时间
        doubleBidOpeningActor: null, // 第二信封开标参与人
        remarks: null, // 备注
        bidOpeningContent: null, // 开标内容
        doubleBidOpeningContent: null, // 第二信封开标内容
        tenderOpinion: null, // 招标人意见
        evaluationMethod: null, // 评标办法
        tenderBondFlag: null, // 保证金标志
        totalInvestment: null, // 批准投资总额
        isAudit: null, // 是否核验
        tenderContentNum: null, // 招标内容
        ebsFlag: null // 电子标标识
      },
      // 公示状态默认不置灰
      publicStateDisabled: false,
      // 招标范围修改原因默认置灰
      tenderScopeUpdateDisabled: true,
      // 全局加载
      fullLoading: null,
      // 主键
      id: this.$route.query.id,
      // 操作类型
      controllerFlg: this.$route.query.type,
      // 附件操作类型
      pictureinforControllerFlg: this.$route.query.type,
      // 甲方确认
      isTenderSignature: this.$route.query.isTenderSignature,
      /***************************中标候选人*****************************/
      // 加载
      loading: false,
      // 表头按钮
      btnList: [],
      // 中标候选人信息绑定数据
      formObj: {
        // 表格数据
        tableData: []
      },
      // 勾选的数据
      multipleSelection: [],
      // 中标候选人信息绑定验证规则
      rules: {
        corpName: [
          {
            required: true,
            message: "请输入中标候选人名称",
            trigger: "blur"
          }
        ],
        enterpriseType: [
          {
            required: true,
            message: "请选择企业所有制类型",
            trigger: "blur"
          }
        ],
        prjManager: [
          {
            required: false,
            message: "请输入项目负责人",
            trigger: "blur"
          }
        ],
        idNumber: [
          {
            required: false,
            message: "请输入身份证号",
            trigger: "blur"
          }
        ],
        qualificationName: [
          {
            required: false,
            message: "请输入证书名称",
            trigger: "blur"
          }
        ],
        qualificationCode: [
          {
            required: false,
            message: "请输入证书编号",
            trigger: "blur"
          }
        ],
        winningPrice: [
          {
            required: true,
            message: "请输入投标报价（万元）",
            trigger: "blur"
          }
        ],
        winningRanking: [
          {
            required: true,
            message: "请输入名次",
            trigger: "blur"
          }
        ],
        winningLimit: [
          {
            required: true,
            message: "请输入工期（日历天）",
            trigger: "blur"
          }
        ],
        qualityStandard: [
          {
            required: true,
            message: "请选择质量标准",
            trigger: "blur"
          }
        ],
        securityManagermentStandard: [
          {
            required: true,
            message: "请输入安全生产管理标准",
            trigger: "blur"
          }
        ],
        cultureManagermentStandard: [
          {
            required: true,
            message: "请输入文明施工管理标准",
            trigger: "blur"
          }
        ],
        qualificationInformation: [
          {
            required: true,
            message: "请输入投标文件中的资格审查资料",
            trigger: "blur"
          }
        ],
        securityCivilizationFee: [
          {
            pattern: /^(0|0(?:\.\d{1,4})?|[1-9]\d{0,7}(?:\.\d{1,6})?)$/,
            message: "请输入整数最多8位，小数最多6位的数字",
            trigger: "blur"
          }
        ],
        deepFoundationFee: [
          {
            pattern: /^(0|0(?:\.\d{1,4})?|[1-9]\d{0,7}(?:\.\d{1,6})?)$/,
            message: "请输入整数最多8位，小数最多6位的数字",
            trigger: "blur"
          }
        ]
      },
      enterpriseTypes: [], // 企业所有制类型
      // 中标候选人信息点击下标
      formObjIndex: null,
      /***************************保证金退还信息*****************************/
      // 保证金退还信息loading
      refundLoading: false,
      // 退还招标单位保证金信息表头按钮
      refundBtnList: [],
      // 退还招标单位保证金信息绑定数据
      refundFormObj: {
        // 表格数据
        tableData: []
      },
      // 勾选的数据
      refundMultipleSelection: [],
      // 退还招标单位保证金信息绑定验证规则
      refundRules: {
        bidCorpName: [
          {
            required: true,
            message: "请选择投标单位",
            trigger: "blur"
          }
        ],
        retFlagReason: [
          {
            required: true,
            message: "请填写退还给招标人理由",
            trigger: "blur"
          }
        ],
        refundWay: [
          {
            required: true,
            message: "请填写退款方式",
            trigger: "blur"
          }
        ],
        refundReason: [
          {
            required: true,
            message: "请填写退款原因",
            trigger: "blur"
          }
        ]
      },

      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      total: 0, // 总条数
      // 保证金信息点击下标
      refundFormObjIndex: null,
      // 文件
      fileChangeList: [],
      /***************************不退还申请表*****************************/
      // 图片预览dialog
      imgVisible: false,
      // 图片路径
      imgUrl: null,
      // 不退还申请表模板路径
      url: null,
      // 不退还申请表加载loading
      pictureLoading: false,
      // 不退还申请表格数据
      pictureData: [],
      // 不退还申请表基础数据
      pictureColumns: [
        {
          label: "上传文件名",
          prop: "pictureName"
        },
        {
          label: "操作",
          slotName: "cz"
        }
      ],
      // 不退还申请信息分页参数
      picturePageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      // 总条数
      pictureTotal: 0,
      /***************************撤回*****************************/
      // 撤回加载loading
      revocationLoading: false,
      // 撤回表格数据
      revocationData: [],
      // 撤回基础数据
      revocationColumns: [
        {
          label: "项目名称",
          prop: "prjName",
          isShow: true
        },
        {
          label: "撤回次数",
          prop: "revocationNum"
        },
        {
          label: "撤回原因",
          prop: "revocationReason"
        },
        {
          label: "撤回时间",
          prop: "backupDate"
        },
        {
          label: "撤回附件",
          slotName: "cz"
        }
      ],
      // 撤回分页参数
      revocationPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      // 总条数
      revocationTotal: 0,
      // 招标人签章状态
      tenderSignedState: null,
      // 是否需要核验
      isDeregulation: null,
      // 公示状态修改标志
      updatePublicState: null,
      // 默认不显示中标候选人弹窗
      dialogVisible: false,
      // 中标候选人选择loading
      tenderLoading: false,
      // 中标候选人选择查询参数
      tenderForm: {
        tenderUnits: null, // 投标单位名称
        basicInfoId: null // 中标候选人编号
      },
      // 中标候选人选择查询条件
      formSearchList: [
        {
          label: "投标单位名称：",
          value: "tenderUnits",
          placeholder: "请输入",
          type: "input"
        }
      ],
      // 中标候选人选择数据
      tenderData: [],
      // 中标候选人选择基础数据
      tenderTableColumns: [
        {
          label: "投标单位名称",
          prop: "tenderUnitsName",
          isShow: true
        },
        {
          label: "下载时间",
          prop: "signUpTime"
        },
        {
          label: "项目负责人姓名",
          prop: "constructorName"
        }
      ],
      // 分页参数
      tenderReqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      // 总条数
      tenderTotal: 0,
      // 招标方式
      tenderTypeNum: null,
      // 是否可以联合体投标
      isUnionCorpEnroll: null,
      // 图片类型
      pictureType: null,
      // 悬浮显示
      isShowTooltip: false,
      // 退还至招标人编号
      accountBasicInfoId: null,
      // 第一名单位编号
      winBasicInfoId: null,
      // 中标候选人中是否存在联合体报名
      unionFlag: "0",
      // 中标候选人信息
      tenderNum: null,
      // 默认关闭弹窗
      innerVisible: false,
      // 默认关闭弹窗
      refundDialogVisible: false,
      // 加载loading
      refundDataLoading: false,
      // 查询参数绑定值
      refundForm: {
        bidCorpName: null // 投标单位名称
      },
      // 查询条件
      refundFormSearchList: [
        {
          label: "投标单位名称：",
          value: "bidCorpName",
          placeholder: "请输入",
          type: "input"
        }
      ],
      // 表格数据
      refundTableData: [],
      // 表格基础数据
      refundTableColumns: [
        {
          label: "投标单位名称",
          prop: "bidCorpName",
          isShow: true
        },
        {
          label: "投标单位代码",
          prop: "bidCorpCode"
        }
      ],
      // 分页参数
      refundReqPageData: {
        current: 1, // 页码
        size: 10 // 条数
      },
      refundTotal: 0, // 总条数
      // 甲方确认表单
      tenderSignedForm: {
        table: null, // 表名
        key: null, // 字段
        recordNumber: null, // 数据编号
        tenderOpinion: null, // 招标人意见
        tenderSignedId: null, // 招标人签章确认编号
        tenderSignedState: null, // 招标人签章状态
        isDeregulation: null, // 添加标记
        esRegulators: null, // 招标人盖章确认的招标监管部门
        esProcessType: null, // 招标人盖章确认的招标监管流程
        esInvitationId: null, // 招标人盖章确认权限编号
        tenderStampData: null, // 招标人盖章的数字签名
        title: null // 判断当前时提交还是退还至招标代理
      },
      // 用于判断状态图片
      flagState: null,
      // 对投标人资格审查方式
      prequalificationType: null,
      // 提交显示验证
      tjButShow: false,
    }
  },

  // 注册组件
  components: {
    CaLock,
    Pictureinfor, // 附件上传
    ModifyHistoryRecord, // 变更历史记录
    AuditHistoryRecord, // 历史核验记录
    ProjectChooseDialog, // 选择项目弹窗
    WinningPublicBackupDetail, // 中标公示备份详情
  },
  // 模板编译完成
  mounted() {
    // 获取不退还申请表路径
    this.fun_GetFileUrl();
    // 获取项目信息
    this.fun_Details();
    // 默认显示第一个表单
    this.formConfigList = this.stepsList[this.stepsActive].formList;
  },

  // 自定义方法
  methods: {
    /**
     * 获取详情
     * @author shuhua
     */
    fun_Details() {
      // 全局加载
      this.fun_Loading();
      // 发起请求
      fun_GetAction("/winningPublicity/detail", {
        id: this.id,
        controllerFlg: this.controllerFlg,
        isTenderSignature: this.isTenderSignature
      }).then(res => {
        // 结构res.data
        const { result, data, msg } = res.data;
        // 请求成功
        if (result) {
          // 回显表单
          for (let key in this.form) {
            // 赋值
            this.form[key] = data.data[key];
          }
          // 获取状态用于判断显示图片
          this.flagState = data.data.state;
          // 状态标志
          this.updatePublicState = data.updatePublicState;
          // 资格预审方式
          this.prequalificationType = data.data.prequalificationType;
          // 判断是否需要项目负责人的值
          if (this.form.isNeedPm === "1") {
            // 赋值
            this.form.isNeedPmName = "是";
          } else {
            // 赋值
            this.form.isNeedPmName = "否";
          }
          // 设置中标候选人样式
          this.fun_WinningCandidateStyle();
          // 获取中标候选人的所有数据
          this.fun_WinningCandidateDetail();
          // 内容变换
          this.fun_SetContent();
          // 甲方确认
          this.fun_GetTenderSignature(data);
          // 关闭加载
          this.fullLoading.close();
        } else {
          // 提示请求失败的信息
          this.$message.error(msg);
          // 关闭加载
          this.fullLoading.close();
        }
      });
    },
    /**
     * 内容变换
     * @author shuhua
     */
    fun_SetContent() {
      // 全局加载
      this.fun_Loading();
      // 如果是详情
      if (this.controllerFlg === "detail") {
        // 遍历流程
        this.stepsList.map(e => {
          e.isSave = true; // 默认保存
          e.isActive = true; // 默认可点击
          // 遍历标签页
          e.formList.map(formList => {
            // 遍历标签页内表单
            formList.formConfigList.map(form => {
              // 置灰
              form.disabled = true;
            });
          });
        });
        // 公示状态置灰
        this.publicStateDisabled = true;
      } else {
        // 核验通过并且公告状态为正常时
        if (this.updatePublicState === "0") {
          // 置灰
          this.stepsList.map(e => {
            // 遍历标签页
            e.formList.map(formList => {
              // 遍历标签页内表单
              formList.formConfigList.map(form => {
                // 除了公示状态 其余置灰
                if (form.value != "publicState") {
                  // 置灰
                  form.disabled = true;
                }
              });
            });
          });
          // 根据公告状态选择是否出现作废框
          this.fun_CancelDivShow();
        }
      }
      // 武汉市工程建设项目评定分离招标文件示范文本（适用于综合评估法）
      if (
        this.form.evaluationMethod === "tenderFile,gcjsxmpdfl,pdflwys" ||
        this.form.evaluationMethod === "202204061014580094"
      ) {
        // 遍历
        this.stepsList[1].formList.map((item, num) => {
          // 匹配中标候选人信息
          if (item.title === "中标候选人信息") {
            // 清空tip
            item.tip = "";
          }
        });
      }

      // 不是查看详情，核验通过并且公告状态为正常时
      if (this.controllerFlg !== "detail" && this.updatePublicState !== "0") {
        // 显示保证金退还信息表表头
        this.refundBtnList = [
          {
            name: "添加",
            type: "success",
            icon: "circle-plus-outline"
          },
          {
            name: "删除",
            type: "danger",
            icon: "delete"
          }
        ];
        // 中标候选人按钮
        this.btnList = [
          {
            name: "添加",
            type: "success",
            icon: "circle-plus-outline"
          },
          {
            name: "删除",
            type: "danger",
            icon: "delete"
          }
        ];
      } else {
        // 清空表头按钮
        this.btnList = [];
        // 清空表头按钮
        this.refundBtnList = [];
      }
      // 保证金样式
      this.fun_ScopeTenderBond();
      // 存在保证金信息
      if (this.form.tenderBondFlag === "1") {
        // 获取保证金退还信息
        this.fun_RefundBidBondList();
        // 不退还申请表
        this.fun_MyFileList();
      }
      // 获取撤回信息一览
      this.fun_MyRevocationList();
      // 如果是否有履约保证金为无
      if (this.form.isPerformanceBondAmount == "0") {
        // 设置履约保证金为空
        this.form.performanceBondAmount = null;
      }
      // 如果是否有工程质量保证金为无
      if (this.form.isProjectQualityDeposit == "0") {
        // 设置工程质量保证金为空
        this.form.projectQualityDeposit = null;
      }
      // 公示状态为空时
      if (this.form.publicState == "" || this.form.publicState == null) {
        // 设置为正常
        this.form.publicState = "0";
      }
      // 不是查看详情，核验通过并且公告状态为正常时
      if (this.controllerFlg !== "detail" && this.updatePublicState !== "0") {
        // 设置招标范围修改原因disabled值
        this.fun_ScopeUpdate(this.fun_ScopeChange());
      } else {
        // 置灰
        this.tenderScopeUpdateDisabled = true;
      }
      // 第二信封样式
      this.fun_ScopeDoubleBidOpening();
      // 关闭加载
      this.fullLoading.close();
    },
    /**
     * 设置招标范围修改原因为可编辑
     * @author shuhua
     */
    fun_ScopeUpdate(rtn) {
      // 不是查看详情，修改公示状态标志不等于0
      if (this.controllerFlg !== "detail" && this.updatePublicState !== "0") {
        // 判断为false则修改原因可编辑
        if (!rtn) {
          // 取消置灰
          this.tenderScopeUpdateDisabled = false;
        } else {
          // 置灰
          this.tenderScopeUpdateDisabled = true;
        }
      } else {
        // 置灰
        this.tenderScopeUpdateDisabled = true;
      }
    },
    /**
     * 判断修改了招标范围则需要填写招标范围修改原因
     * @author shuhua
     */
    fun_ScopeChange() {
      // 都为空时
      if (
        (this.form.regTenderContent == "" ||
          this.form.regTenderContent == null) &&
        this.form.tenderScope == null
      ) {
        // 返回结果
        return true;
      } else {
        // 判断是否修改了招标范围
        if (this.form.regTenderContent !== this.form.tenderScope) {
          // 返回结果
          return false;
        } else {
          // 返回结果
          return true;
        }
      }
    },
    /**
     * 修改第二信封样式
     */
    fun_ScopeDoubleBidOpening() {
      // 第二信封参与人为空
      if (
        this.form.doubleBidOpeningActor == "" ||
        this.form.doubleBidOpeningActor == null
      ) {
        // 遍历
        this.stepsList[2].formList.map((item, num) => {
          // 匹配第二信封开标记录信息
          if (item.title === "第二信封开标记录信息") {
            // 删除
            this.stepsList[2].formList.splice(num, 1);
          }
        });
        // 遍历
        this.stepsList[2].formList.map((item, num) => {
          // 匹配第二信封开标记录信息
          if (item.title === "第二信封开标内容") {
            // 删除
            this.stepsList[2].formList.splice(num, 1);
          }
        });
      }
      // 第二信封参与人不为空
      else {
        // 操作标识
        let rtn = false;
        // 表单下标
        let configNum = 0;
        // 遍历
        this.stepsList[2].formList.map((item, num) => {
          // 匹配第二信封开标记录信息
          if (item.title === "第二信封开标记录信息") {
            // 赋值
            rtn = true;
          }
        });
        // 不存在第二信封
        if (!rtn) {
          // 插入撤回
          this.stepsList[2].formList.splice(
            this.stepsList[2].formList.length - 1,
            0,
            {
              title: "第二信封开标记录信息",
              name: "3",
              icon: "",
              class: "doubleBidOpeningRecord",
              formConfigList: [
                {
                  label: "公开类型：",
                  value: "doubleOpenType",
                  type: "input",
                  disabled: true
                },
                {
                  label: "开标地点：",
                  value: "doubleBidOpeningAddress",
                  type: "input",
                  disabled: true
                },
                {
                  label: "开标时间：",
                  value: "doubleBidOpeningTime",
                  type: "input",
                  disabled: true
                },
                {
                  label: "开标参与人：",
                  value: "doubleBidOpeningActor",
                  type: "textarea",
                  disabled: true
                }
              ]
            },
            {
              title: "第二信封开标内容",
              name: "4",
              icon: "",
              formConfigList: [
                {
                  label: "",
                  type: "slot",
                  class: "list",
                  slotName: "doubleBidOpeningContent"
                }
              ]
            }
          );
        }
      }
    },
    /**
     * 修改保证金样式
     */
    fun_ScopeTenderBond() {
      // 存在保证金信息
      if (this.form.tenderBondFlag === "1") {
        // 操作标识
        let rtn = false;
        // 表单下标
        let configNum = 0;
        // 遍历
        this.stepsList[1].formList.map((item, num) => {
          // 匹配中标候选人信息
          if (item.title === "中标候选人信息") {
            // 设置表单下标
            configNum = num;
          }
          // 匹配退还招标单位保证金信息
          else if (item.title === "退还招标单位保证金信息") {
            // 操作标识
            rtn = true;
            // 查看详情
            if (this.controllerFlg === "detail") {
              // 修改标题
              item.title = "保证金退还信息表";
              // 遍历
              item.formConfigList.map((e, i) => {
                // 匹配文件上传
                if (e.slotName === "refundFile") {
                  // 删除
                  item.formConfigList.splice(i, 1);
                }
              });
            }
          }
        });
        // 不存在保证金信息
        if (!rtn) {
          // 声明一个对象
          let obj = {
            title: "保证金退还信息表",
            name: "5",
            icon: "",
            formConfigList: [
              {
                label: "",
                type: "slot",
                class: "list",
                slotName: "refundData"
              },
              {
                label: "文件上传：",
                type: "slot",
                slotName: "refundFile",
                tipContent: "请上传jpg，gif或png格式的图片"
              }
            ]
          };
          // 插入退还招标单位保证金信息
          this.stepsList[1].formList.splice(configNum + 1, 0, obj);
        }
      }
      // 如果不存在保证金退还
      else {
        // 遍历
        this.stepsList[1].formList.map((item, num) => {
          // 匹配退还招标单位保证金信息
          if (item.title === "退还招标单位保证金信息") {
            // 删除
            this.stepsList[1].formList.splice(num, 1);
          }
        });
        // 遍历
        this.stepsList[1].formList.map((item, num) => {
          // 匹配保证金退还信息表
          if (item.title === "保证金退还信息表") {
            // 删除
            this.stepsList[1].formList.splice(num, 1);
          }
        });
        // 遍历
        this.stepsList[1].formList.map((item, num) => {
          // 匹配不退还申请表
          if (item.title === "不退还申请表") {
            // 删除
            this.stepsList[1].formList.splice(num, 1);
          }
        });
      }
    },
    /**
     * 获取不退还申请表一览
     * @author shuhua
     */
    fun_MyFileList() {
      // 打开加载loading
      this.pictureLoading = true;
      // 发起请求
      fun_PostAction(
        "/tenderPictureinfor/prequalificationTenderPictureinforList",
        {
          ...this.picturePageData,
          tenderReference: this.form.tenderReference,
          type: "31"
        }
      ).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 中标候选人信息
          this.pictureData = data.records;
          // 总条数
          this.pictureTotal = data.total;
          // 关闭加载loading
          this.pictureLoading = false;
        } else {
          // 错误提示
          this.$message.error(msg);
          // 关闭加载loading
          this.pictureLoading = false;
        }
      });
    },
    /**
     * 获取保证金退还信息
     * @author shuhua
     */
    fun_RefundBidBondList() {
      // 打开加载loading
      this.refundLoading = true;
      // 发起请求
      fun_PostAction("/winningPublicity/winningRefundBidList", {
        ...this.reqPageData,
        tenderReference: this.form.tenderReference,
        dataType: "1",
        flag: this.controllerFlg === "detail" ? "2" : "0"
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 声明变量
          let d = data.records;
          // 遍历
          d.map(element => {
            // 赋值
            element.retFlag = element.retFlag;
            // 赋值
            element.retFlagName =
              this.updatePublicState === "0" || this.controllerFlg === "detail"
                ? element.retFlag === "1"
                  ? "否"
                  : "是"
                : "是";
            // 赋值
            element.bidCorpName = element.bidCorpName
              ? element.bidCorpName.indexOf("@") > 0
                ? element.bidCorpName.substring(
                    0,
                    element.bidCorpName.indexOf("@")
                  )
                : element.bidCorpName
              : "";
          });
          // 赋值
          this.refundFormObj.tableData = d;
          // 总条数
          this.total = data.total;
          // 关闭加载loading
          this.refundLoading = false;
        } else {
          // 错误提示
          this.$message.error(msg);
          // 关闭加载loading
          this.refundLoading = false;
        }
      });
    },
    /**
     * 获取企业所有制类型下拉框
     */
    fun_GetEnterpriseTypeSelect() {
      // 请求，获取结果集
      fun_PostAction("/dataDictionaryEntries/BasicDataCombobox", {
        zdid: "202407181436541697"
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 企业所有制类型下拉框
          this.enterpriseTypes = data;
        } else {
          this.$message.error(msg);
        }
      });
    },
    /**
     * 获取中标候选人的所有数据
     * @author shuhua
     */
    fun_WinningCandidateDetail() {
      // 企业所有制类型下拉框
      this.fun_GetEnterpriseTypeSelect();
      // 打开加载loading
      this.loading = true;
      // 发起请求
      fun_PostAction("/winningPublicity/winningCandidateList", {
        publicityNumber: this.id,
        tenderReference: this.form.tenderReference
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 声明变量
          let d = data;
          // 遍历
          d.map(element => {
            // 赋值
            element.corpName = element.corpName
              ? element.corpName.indexOf("@") > 0
                ? element.corpName.substring(0, element.corpName.indexOf("@"))
                : element.corpName
              : "";
          });
          // 中标候选人信息
          this.formObj.tableData = d;
          // 关闭加载loading
          this.loading = false;
          // 提交显示
          this.tjButShow = true;
        } else {
          // 错误提示
          this.$message.error(msg);
          // 关闭加载loading
          this.loading = false;
        }
      });
    },
    /**
     * 撤回一览
     */
    fun_MyRevocationList() {
      // 打开加载loading
      this.revocationLoading = true;
      // 发起请求
      fun_PostAction("/winningPublicity/winningPublicBackupList", {
        ...this.revocationPageData,
        tenderReference: this.form.tenderReference
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 中标候选人信息
          this.revocationData = data.records;
          // 总条数
          this.revocationTotal = data.total;
          // 关闭加载loading
          this.revocationLoading = false;
        } else {
          // 错误提示
          this.$message.error(msg);
          // 关闭加载loading
          this.revocationLoading = false;
        }
      });
    },
    /**
     * 撤回附件查看
     * @author shuhua
     */
    fun_WinningPublicBackupUpload(e) {
      // 打开弹窗
      this.$refs.pictureinfor.dialogVisible = true;
      // 图片类型
      this.pictureType = "33";
      // 查看详情
      this.pictureinforControllerFlg = "detail";
      // 数据编号
      this.$refs.pictureinfor.form.recordNumber =
        e.winningPublicityId + e.revocationNum;
      // 执行初始化方法
      this.$refs.pictureinfor.fun_GetOpen();
    },
    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_GetSelectVal(e, i) {
      // 赋值
      this.form[i] = e;
      // 是否有履约保证金
      if (i == "isPerformanceBondAmount") {
        // 有履约保证金
        if (this.form.isPerformanceBondAmount === "1") {
          // 遍历
          this.stepsList[0].formList.map((item, num) => {
            // 匹配中标项目基本信息
            if (item.title === "中标项目基本信息") {
              // 遍历
              item.formConfigList.map(val => {
                // 匹配履约保证金金额
                if (val.value === "performanceBondAmount") {
                  // 取消置灰
                  val.disabled = false;
                  // 必填验证
                  val.rule = [
                    {
                      required: true,
                      message: "该输入项不能为空",
                      trigger: "blur"
                    },
                    {
                      pattern: /^([1-9]\d*|0)(\.\d{1,6})?$$/,
                      message: "请输入数字"
                    }
                  ];
                }
              });
            }
          });
        }
        // 如果没有履约保证金
        else {
          // 遍历
          this.stepsList[0].formList.map((item, num) => {
            // 匹配中标项目基本信息
            if (item.title === "中标项目基本信息") {
              // 遍历
              item.formConfigList.map(val => {
                // 匹配履约保证金金额
                if (val.value === "performanceBondAmount") {
                  // 置灰
                  val.disabled = true;
                  // 取消必填验证
                  val.rule = [
                    {
                      required: false,
                      message: "该输入项不能为空",
                      trigger: "blur"
                    },
                    {
                      pattern: /^([1-9]\d*|0)(\.\d{1,6})?$$/,
                      message: "请输入数字"
                    }
                  ];
                }
              });
            }
          });
          // 清空履约保证金
          this.form.performanceBondAmount = "";
        }
      }
      // 是否有工程质量保证金
      else if (i == "isProjectQualityDeposit") {
        // 有工程质量保证金
        if (this.form.isProjectQualityDeposit === "1") {
          // 遍历
          this.stepsList[0].formList.map((item, num) => {
            // 匹配中标项目基本信息
            if (item.title === "中标项目基本信息") {
              // 遍历
              item.formConfigList.map(val => {
                // 匹配工程质量保证金
                if (val.value === "projectQualityDeposit") {
                  // 置灰
                  val.disabled = false;
                  // 必填验证
                  val.rule = [
                    {
                      required: true,
                      message: "该输入项不能为空",
                      trigger: "blur"
                    },
                    {
                      pattern: /^([1-9]\d*|0)(\.\d{1,6})?$$/,
                      message: "请输入数字"
                    }
                  ];
                }
              });
            }
          });
        }
        // 如果没有工程质量保证金
        else {
          // 遍历
          this.stepsList[0].formList.map((item, num) => {
            // 匹配中标项目基本信息
            if (item.title === "中标项目基本信息") {
              // 遍历
              item.formConfigList.map(val => {
                // 匹配履约保证金金额
                if (val.value === "projectQualityDeposit") {
                  // 置灰
                  val.disabled = true;
                  // 取消必填验证
                  val.rule = [
                    {
                      required: false,
                      message: "该输入项不能为空",
                      trigger: "blur"
                    },
                    {
                      pattern: /^([1-9]\d*|0)(\.\d{1,6})?$$/,
                      message: "请输入数字"
                    }
                  ];
                }
              });
            }
          });
          // 清空履工程质量保证金
          this.form.projectQualityDeposit = "";
        }
      }
    },
    /**
     * 公示状态下拉框值改变事件
     * @author shuhua
     */
    fun_ChangePublicState(e) {
      // 赋值
      this.form.publicState = e.code;
      // 根据公告状态选择是否出现作废框
      this.fun_CancelDivShow();
    },
    /**
     * 根据公示状态选择是否出现撤销
     * @author shuhua
     */
    fun_CancelDivShow() {
      // 清空撤回原因
      this.form.revocationReason = null;
      // 是否存在撤回原因
      let rtn = false;
      // 公示状态下标
      let stateNum = 0;
      // 撤回原因下标
      let revocationReasonNum = 0;
      // 遍历
      this.stepsList[0].formList.map((item, num) => {
        // 如果是中标项目基本信息
        if (item.title === "中标项目基本信息") {
          // 遍历
          item.formConfigList.map((element, index) => {
            // 匹配公示状态
            if (element.value === "publicState") {
              // 设置下标
              stateNum = index;
            }
            // 匹配撤回原因
            else if (element.value === "revocationReason") {
              // 设置存在
              rtn = true;
              // 设置下标
              revocationReasonNum = index;
            }
          });
        }
      });
      // 如果公告状态为撤回
      if (this.form.publicState == "2") {
        // 如果不存在
        if (!rtn) {
          // 插入撤回
          this.stepsList[0].formList[0].formConfigList.splice(stateNum + 1, 0, {
            label: "撤回原因：",
            value: "revocationReason",
            type: "textarea",
            maxlength: "1200",
            width: "100%;",
            disabled: false,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "change"
            }
          });
        }
      }
      // 如果是正常公告
      else {
        // 如果存在撤回原因
        if (rtn) {
          // 删除撤回原因
          this.stepsList[0].formList[0].formConfigList.splice(
            revocationReasonNum,
            1
          );
        }
      }
    },
    /**
     * 表头按钮事件
     * @params e 按钮name
     * @author 滕威
     */
    fun_click(e) {
      switch (e) {
        case "添加":
          // 调用添加方法
          var newValue = {
            corpName: null,
            basicInfoCode: null,
            isUnionTender: null,
            tenderUnitsNotMainName: null,
            prjManager: null,
            idNumber: null,
            qualificationName: null,
            qualificationCode: null,
            professionalCategory: null,
            qualificationGrade: null,
            winningPrice: null,
            winningEstimatedAmount: null,
            bidPriceText: null,
            winningRanking: null,
            winningLimit: null,
            qualityStandard: null,
            securityManagermentStandard: null,
            cultureManagermentStandard: null,
            qualificationInformation: null,
            securityCivilizationFee: null,
            deepFoundationFee: null
          };
          //添加新的行数
          this.formObj.tableData.push(newValue);
          break;
        default:
          // 判断是否勾选
          if (this.multipleSelection.length <= 0) {
            // 提示信息
            this.$alert("最少选择一条数据！", "warning");
            return;
          }
          // 弹出询问confirm
          this.$confirm("是否确定删除选中数据?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            // 遍历
            this.multipleSelection.map((value, index) => {
              // 遍历
              this.formObj.tableData.map((v, i) => {
                // 匹配已选中的
                if (value.index === v.index) {
                  // 删除勾选的数据
                  this.formObj.tableData.splice(i, 1);
                }
              });
            });
            // 清除选中数据
            this.$refs.multipleTable.clearSelection();
          });
      }
    },
    /**
     * 表头按钮事件
     * @params e 按钮name
     * @author 滕威
     */
    fun_RefundClick(e) {
      switch (e) {
        case "添加":
          // 调用添加方法
          var newValue = {
            bidCorpName: null,
            bidCorpCode: null,
            retFlag: null,
            retFlagName: null,
            retFlagReason: null,
            refundWay: null,
            refundReason: null,
            refundDescription: null
          };
          //添加新的行数
          this.refundFormObj.tableData.push(newValue);
          break;
        default:
          // 判断是否勾选
          if (this.refundMultipleSelection.length <= 0) {
            // 提示信息
            this.$alert("最少选择一条数据！", "warning");
            return;
          }
          // 弹出询问confirm
          this.$confirm("是否确定删除选中数据?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            // 遍历
            this.refundMultipleSelection.map((value, index) => {
              // 遍历
              this.refundFormObj.tableData.map((v, i) => {
                // 匹配已选中的
                if (value.index === v.index) {
                  // 删除勾选的数据
                  this.refundFormObj.tableData.splice(i, 1);
                }
              });
            });
            // 清除选中数据
            this.$refs.refundMultipleTable.clearSelection();
          });
      }
    },
    /**
     * 上传文件
     */
    fun_FileChange(file, fileList) {
      // 获取文件后缀名
      const suffix = file.name
        .substring(file.name.lastIndexOf(".") + 1)
        .toLowerCase();
      // 这里限定上传文件文件类型必须为jpg，gif或png，如果文件类型不符，提示错误信息
      if (suffix == "jpg" || suffix == "gif" || suffix == "png") {
        if (fileList.length === 1) {
          this.fileChangeList = fileList;
        }
        if (fileList.length > 1) {
          const list = fileList.pop();
          this.fileChangeList = [list];
        }
      } else {
        // 清除文件
        this.$refs.fileUpload.clearFiles();
        // 提示错误消息
        this.$message.error("图片格式有误，请上传jpg或gif或png格式的图片");
        // 返回
        return false;
      }
    },
    /**
     * 移除文件
     * @author shuhua
     */
    handleRemove(file) {
      // 文件集合为空
      this.fileChangeList = [];
    },
    /**
     * 列表添加class
     */
    addClass(row, column, rowIndex, columnIndex) {
      // 判断是序号
      if (row.column.type === "index") {
        return "index";
      }
    },
    /**
     * 添加时执行的方法
     * @author shuhua
     */
    tableRowClassName(row, rowIndex) {
      // 给每一行新增一个下标
      row.row.index = row.rowIndex;
    },
    /**
     * 中标候选人按钮点击事件
     * @author shuhua
     */
    fun_NationalName(index) {
      // 招标编号为空
      if (!this.form.tenderReference) {
        // 错误提示
        this.$alert("请先选择招标项目！", "warning");
        return;
      }
      // 判断是否修改
      if (this.updatePublicState !== "0") {
        // 存储点击的下标
        this.formObjIndex = index;
        // 打开弹窗
        this.dialogVisible = true;
        // 获取项目详情
        this.fun_GetPrjDetail();
      }
    },
    /**
     * 关联保证金投标单位选择
     * @author shuhua
     */
    fun_RefundCorpNameChoose(index) {
      // 存储点击的下标
      this.refundFormObjIndex = index;
      // 打开弹窗
      this.refundDialogVisible = true;
      // 打开弹窗
      this.innerVisible = true;
      // 获取一览
      this.fun_WinningRefundSelectList();
    },
    /**
     * 保证金投标单位一览
     */
    fun_WinningRefundSelectList() {
      // 打开加载loading
      this.refundDataLoading = true;
      // 发起请求
      fun_PostAction("/winningPublicity/winningRefundSelectList", {
        ...this.refundForm,
        ...this.refundReqPageData,
        tenderReference: this.form.tenderReference
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 中标候选人信息
          this.refundTableData = data.records;
          // 总条数
          this.refundTotal = data.total;
          // 关闭加载loading
          this.refundDataLoading = false;
        } else {
          // 错误提示
          this.$message.error(msg);
          // 关闭加载loading
          this.refundDataLoading = false;
        }
      });
    },
    /**
     * 关联保证金投标单位选择
     * @author shuhua
     */
    fun_SetRefundCorp(e) {
      // 询问框
      this.$confirm(
        '<span style="color:red">请确定<strong>' +
          e.val.bidCorpName +
          "</strong>的保证金是要 <strong> 退还至招标人 </strong>吗？</span>",
        "提示",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      ).then(() => {
        // 赋值
        this.refundFormObj.tableData[this.refundFormObjIndex].bidCorpName =
          e.val.bidCorpName;
        // 赋值
        this.refundFormObj.tableData[this.refundFormObjIndex].bidCorpCode =
          e.val.bidCorpCode;
        // 赋值
        this.refundFormObj.tableData[this.refundFormObjIndex].conSeqNo =
          e.val.conSeqNo;
        // 赋值
        this.refundFormObj.tableData[this.refundFormObjIndex].refundId =
          e.val.refundId;
        // 赋值
        this.refundFormObj.tableData[this.refundFormObjIndex].refundCorpId =
          e.val.basicInfoId;
        // 赋值
        this.refundFormObj.tableData[this.refundFormObjIndex].retFlag = "0";
        // 赋值
        this.refundFormObj.tableData[this.refundFormObjIndex].retFlagName =
          "是";
        // 关闭弹窗
        this.refundDialogVisible = false;
      });
    },
    /**
     * 获取项目详情信息
     * @author shuhua
     */
    fun_GetPrjDetail() {
      // 发起请求
      fun_PostAction("/winningPublicity/getPrjDeatil", {
        tenderReference: this.form.tenderReference
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 中标候选人信息
          this.tenderTypeNum = data.tenderTypeNum;
          // 总条数
          this.isUnionCorpEnroll = data.isUnionCorpEnroll;
          // 修改中标候选人选择表头
          this.fun_SetTenderTableColumns();
        }
      });
    },
    /**
     * 修改中标候选人选择表头
     * @author shuhua
     */
    fun_SetTenderTableColumns() {
      // 邀请招标
      if (this.tenderTypeNum !== "001") {
        // 修改中标候选人选择表头
        this.tenderTableColumns = [
          {
            label: "投标单位名称",
            prop: "tenderUnitsName",
            isShow: true
          },
          {
            label: "邀请时间",
            prop: "signUpTime"
          },
          {
            label: "项目负责人姓名",
            prop: "constructorName"
          }
        ];
      }
      // 若为允许联合体投标，则显示是否联合体栏
      if (this.isUnionCorpEnroll === "1") {
        // 插入
        this.tenderTableColumns.push(
          {
            label: "是否联合体投标",
            prop: "isUnionTender"
          },
          {
            label: "联合投标非主体单位",
            prop: "tenderUnitsNotMainName"
          }
        );
      }
      // 获取中标候选人选择一览
      this.fun_GetPrjTenderList();
    },
    /**
     * 设置中标候选人表单样式
     */
    fun_WinningCandidateStyle() {
      // 判断需要项目负责人
      if (this.form.isNeedPm === "1") {
        // 遍历
        for (let i in this.rules) {
          // 如果是项目负责人相关
          if (
            i == "prjManager" ||
            i == "idNumber" ||
            i == "qualificationName" ||
            i == "qualificationCode"
          ) {
            // 遍历数组
            this.rules[i].map(v => {
              // 设置为必填
              v.required = true;
            });
          }
        }
      }
      // 如果不需要项目负责人
      else {
        // 遍历
        for (let i in this.rules) {
          // 如果是项目负责人相关
          if (
            i == "prjManager" ||
            i == "idNumber" ||
            i == "qualificationName" ||
            i == "qualificationCode"
          ) {
            // 遍历数组
            this.rules[i].map(v => {
              // 取消为必填
              v.required = false;
            });
          }
        }
      }
    },
    /**
     * 获取中标候选人选择一览
     * @author shuhua
     */
    fun_GetPrjTenderList() {
      // 中标候选人
      let basicInfoId = "";
      // 遍历
      this.formObj.tableData.map(v => {
        // 交易人编号不为空
        if (v.basicInfoId) {
          // 拼接
          basicInfoId += v.basicInfoId + ",";
        }
      });
      // 赋值
      this.tenderForm.basicInfoId = basicInfoId.slice(0, -1);
      // 打开加载
      this.tenderLoading = true;
      // 发起请求
      fun_PostAction("/winningPublicity/prjTenderPageList", {
        ...this.tenderForm,
        ...this.tenderReqPageData,
        tenderReference: this.form.tenderReference
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 中标候选人信息
          this.tenderData = data.records;
          // 总条数
          this.tenderTotal = data.total;
          // 关闭加载loading
          this.tenderLoading = false;
        } else {
          // 错误提示
          this.$message.error(msg);
          // 关闭加载loading
          this.tenderLoading = false;
        }
      });
    },
    /**
     * 中标候选人返回值选择
     * @author shuhua
     */
    fun_SetTenderUnits(e) {
      // 赋值
      this.formObj.tableData[this.formObjIndex].corpName =
        e.val.tenderUnitsName;
      // 赋值
      this.formObj.tableData[this.formObjIndex].basicInfoId = e.val.tenderUnits;
      // 赋值
      this.formObj.tableData[this.formObjIndex].basicInfoCode =
        e.val.basicInfoCode;
      // 赋值
      this.formObj.tableData[this.formObjIndex].isUnionTender =
        e.val.isUnionTender;
      // 赋值
      this.formObj.tableData[this.formObjIndex].tenderUnitsNotMainName =
        e.val.tenderUnitsNotMainName;
      // 赋值
      this.formObj.tableData[this.formObjIndex].prjManager =
        e.val.constructorName;
      // 赋值
      this.formObj.tableData[this.formObjIndex].tenderUnitsName =
        e.val.tenderUnitsName;
      // 赋值
      this.formObj.tableData[this.formObjIndex].idNumber = e.val.idCard;
      // 赋值
      this.formObj.tableData[this.formObjIndex].unionAgreementId =
        e.val.unionAgreementId;
      // 关闭弹窗
      this.dialogVisible = false;
    },
    /**
     * 获取项目选择一览
     * @author shuhua
     */
    fun_ProjectInfo() {
      // 赋值查询标志
      this.$refs.projectChooseDialog.flag = "winning";
      // 打开弹窗
      this.$refs.projectChooseDialog.dialogVisible = true;
      // 获取项目选择一览信息
      this.$refs.projectChooseDialog.fun_GetList();
    },
    /**
     * 项目选择返回
     * @author shuhua
     */
    fun_SetProject(e) {
      // 批准投资总额
      this.form.totalInvestment = e.totalInvestment;
      // 评标办法
      this.form.evaluationMethod = e.evaluationMethod;
      // 是否核验
      this.form.isAudit = e.isAudit;
      // 武汉市工程建设项目评定分离招标文件示范文本（适用于综合评估法）
      if (
        this.form.evaluationMethod === "tenderFile,gcjsxmpdfl,pdflwys" ||
        this.form.evaluationMethod === "202204061014580094"
      ) {
        // 遍历
        this.formConfigList.map((item, num) => {
          // 匹配中标候选人信息
          if (item.title === "中标候选人信息") {
            // 清空tip
            item.tip = "";
          }
        });
      }
      // 根据招标编号读取项目信息
      this.fun_ProjectSetValue(e.id);
    },
    /**
     * 根据招标编号读取项目信息
     * @author shuhua
     */
    fun_ProjectSetValue(e) {
      // 发起请求
      fun_PostAction("/winningPublicity/projectSetValue", {
        id: e
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 遍历
          for (const key in data) {
            // 赋值
            this.form[key] = data[key];
          }
          // 判断是否需要项目负责人的值
          if (this.form.isNeedPm === "1") {
            // 赋值
            this.form.isNeedPmName = "是";
          } else {
            // 赋值
            this.form.isNeedPmName = "否";
          }
          // 公示状态为空时
          if (this.form.publicState == "" || this.form.publicState == null) {
            // 设置为正常
            this.form.publicState = "0";
          }
          // 招标范围不为空
          if (this.form.tenderScope) {
            // 赋值
            this.form.tenderScope = this.form.tenderScope;
            // 赋值
            this.form.regTenderContent = this.form.tenderScope;
          }
          // 开标参与人不为空
          if (this.form.bidOpeningActor) {
            // 赋值
            this.form.bidOpeningActor = decodeURIComponent(
              this.form.bidOpeningActor
            );
          }
          // 第二信封开标参与人不为空
          if (this.form.doubleBidOpeningActor) {
            // 赋值
            this.form.doubleBidOpeningActor = decodeURIComponent(
              this.form.doubleBidOpeningActor
            );
          }
          // 建设规模
          if (this.form.prjSize) {
            // 赋值
            this.form.prjSize = decodeURIComponent(this.form.prjSize);
          }
          // 开标内容不为空
          if (this.form.bidOpeningContent) {
            // 开标内容
            this.form.bidOpeningContent = decodeURIComponent(
              this.form.bidOpeningContent
            );
          }
          // 第二信封样式
          this.fun_ScopeDoubleBidOpening();
          // 第二信封开标内容不为空
          if (this.form.doubleBidOpeningContent) {
            // 第二信封开标内容
            this.form.doubleBidOpeningContent = decodeURIComponent(
              this.form.doubleBidOpeningContent
            );
          }
          // 保证金样式
          this.fun_ScopeTenderBond();
          // 保证金标志
          if (this.form.tenderBondFlag === "1") {
            // 清空保证金信息
            this.refundFormObj.tableData = [];
          }
          // 清空中标候选人数据
          this.formObj.tableData = [];
          // 中标候选人表单样式
          this.fun_WinningCandidateStyle();
          // 获取中标候选人的所有数据
          this.fun_WinningCandidateDetail();
        } else {
          // 错误消息提示
          this.$message.error(msg);
        }
      });
    },
    /**
     * 打开上传附件弹窗
     * @author shuhua
     */
    fun_OpenUpload() {
      // 打开弹窗
      this.$refs.pictureinfor.dialogVisible = true;
      // 图片类型
      this.pictureType = "33";
      // 修改
      this.pictureinforControllerFlg = this.controllerFlg;
      // 如果撤回次数不为空
      if (this.form.revocationNum) {
        // 数据编号
        this.$refs.pictureinfor.form.recordNumber =
          this.id + (parseInt(this.form.revocationNum) + 1);
      } else {
        // 数据编号
        this.$refs.pictureinfor.form.recordNumber = this.id + "1";
      }
      // 打开弹框时调用
      this.$refs.pictureinfor.fun_GetOpen();
    },
    /**
     * 打开变更历史记录弹窗
     */
    fun_OpenModifyHistoryRecord() {
      // 打开弹窗
      this.$refs.modifyHistoryRecord.dialogVisible = true;
      // 请求接口
      this.$refs.modifyHistoryRecord.fun_GetList();
    },
    /**
     * 打开历史核验记录弹窗
     */
    fun_OpenAuditHistoryRecord() {
      // 打开弹窗
      this.$refs.auditHistoryRecord.dialogVisible = true;
      // 请求接口
      this.$refs.auditHistoryRecord.fun_GetList();
    },
    /**
     * 图片预览
     */
    fun_LookImg(e) {
      // 获取id
      fun_Download("/downloadLocal?filePath=" + e).then(res => {
        if (res) {
          if (res.data.type === "application/json") {
            this.$message.error("文件不存在！");
            return;
          }
          // 存储this
          const _this = this;
          const data = new Blob([res.data]);
          this.fun_GetBlobToBase64(data).then(res => {
            // 打开弹窗
            this.imgVisible = true;
            // 回显图片
            _this.imgUrl = res;
          });
        }
      });
    },
    /**
     * 转为base64URL
     * @author 滕威
     */
    fun_GetBlobToBase64(blob) {
      return new Promise((resolve, reject) => {
        // 创建文件对象
        const reader = new FileReader();
        reader.onload = e => {
          resolve(e.target.result);
        };
        reader.readAsDataURL(blob);
        reader.onerror = () => {
          reject(new Error("文件流异常！"));
        };
      });
    },
    /**
     * 文件下载
     */
    fun_Download(e) {
      // 获取id
      fun_Download("/downloadLocal?filePath=" + e).then(res => {
        if (res) {
          // 获取头部
          let fileNames = res.headers["content-disposition"]; //获取到Content-Disposition;filename
          let regFileNames = fileNames.match(/=(.*)$/)[1];
          fun_DownloadFile(res, decodeURIComponent(regFileNames));
        }
      });
    },
    /**
     * 确定的方法
     * @author shuhua
     */
    fun_Confirm(state) {
      // 如果是保存
      if (state === "bc") {
        // 提交的方法
        this.fun_Submit(state, "0");
        return;
      }
      // 自定义下标
      let i = 0;
      // 验证当前表单
      this.$refs.collapseForm.$refs.enInform.validate(valid => {
        // 验证通过
        if (valid) {
          // 重置表单
          this.formConfigList = this.stepsList[i].formList;
          this.$nextTick(() => {
            // 验证表单
            this.fun_val(i, state);
          });
        } else {
          // 提示
          this.$alert("页面存在错误信息，请检查后重试！", "warning");
          return false;
        }
      });
    },
    /**
     * 效验项目负责人与报名是否一致
     * @author shuhua
     */
    fun_ManagerValidation(state) {
      // 退还至招标人编号
      this.accountBasicInfoId = "";
      // 第一名单位编号
      this.winBasicInfoId = "";
      // 声明判断标识
      var rtn = false;
      // 声明判断标识
      var winRtn = false;
      // 声明证书信息标识
      var qualificationRtn = false;
      // 用于存储国家代码
      var tenderNum = "";
      // 联合体集合
      var unionInfo = "";
      // 创建中标候选人信息集合
      var winCandidates = new Array();
      // 遍历
      this.formObj.tableData.forEach(item => {
        // 中标候选人为空
        if (!item.corpName) {
          // 跳转到中标候选人信息
          this.stepsActive = 1;
          // 重置表单配置
          this.formConfigList = this.stepsList[1].formList;
          // 错误提示
          this.$alert(
            "您选的中标候选人中存在中标人名称为空的情况，请确认数据正确！",
            "warning"
          );
          return;
        }
        // 中标候选人联合体报名信息不为空
        if (item.unionAgreementId) {
          // 存在联合体报名
          this.unionFlag = "1";
        }
        // 初始化中标候选人信息
        var winCandidateInfo = { basicInfoId: "", xmjlsfz: "", xmjlxm: "" };
        // 中标候选人编码不为空
        if (item.basicInfoId) {
          // 中标候选人编码
          winCandidateInfo.basicInfoId = item.basicInfoId;
          // 联合体信息
          unionInfo =
            item.unionAgreementId +
            "_" +
            winCandidateInfo.basicInfoId +
            "_" +
            item.tenderUnitsNotMainName +
            ";";
        }
        // 项目负责人身份证不为空
        if (item.idNumber) {
          // 项目负责人身份证
          winCandidateInfo.xmjlsfz = item.idNumber;
          // 项目负责人姓名
          winCandidateInfo.xmjlxm = item.prjManager;
          // 如果存在填写的项目负责人则进行效验
          rtn = true;
        }
        // 中标候选人名称							// 招标人名称			// 中标候选人编号						// 是否联合体			// 是否联合体主体					// 组织机构代码
        var key =
          item.basicInfoId +
          ";" +
          item.corpName +
          ";" +
          winCandidateInfo.basicInfoId +
          ";" +
          item.unionAgreementId +
          ";" +
          item.tenderUnitsNotMainName +
          ";" +
          item.basicInfoCode;
        // 拼接
        tenderNum = key + "!" + tenderNum;
        // 中标候选人信息装入候选信息集合
        winCandidates.push(winCandidateInfo);
      });
      // 声明名字有无第一名
      var rankOne = false;
      // 选择多条记录时，进行数据拼接
      var arr = new Array();
      // 遍历
      this.formObj.tableData.map(item => {
        // 如果中标价为0
        if (item.winningPrice === 0) {
          // 如果投标报价（费率）为空或者中标估算金额为空
          if (
            !item.bidPriceText ||
            item.winningEstimatedAmount == 0 ||
            !item.winningEstimatedAmount
          ) {
            // 操作标识
            winRtn = true;
          }
        }
        // 弹出错误提示
        if (winRtn) {
          // 跳转到中标候选人信息
          this.stepsActive = 1;
          // 重置表单配置
          this.formConfigList = this.stepsList[1].formList;
          // 错误提示
          this.$alert(
            "投标报价为0，请填写中标估算金额与投标报价（费率）！",
            "warning"
          );
          return;
        }
        // 选中框为正常
        if (this.form.publicState == "0") {
          // 非空检查
          if (item.idNumber) {
            // 如果证书名称为空
            if (!item.qualificationName) {
              // 修改标识
              qualificationRtn = true;
            }
            // 弹出错误提示
            if (qualificationRtn) {
              // 跳转到中标候选人信息
              this.stepsActive = 1;
              // 重置表单配置
              this.formConfigList = this.stepsList[1].formList;
              // 错误提示
              this.$alert(
                "证书名称为空，请填写证书名称与证书编号！",
                "warning"
              );
              return;
            }
            // 如果证书编号为空
            if (!item.qualificationCode) {
              // 修改标识
              qualificationRtn = true;
            }
            // 弹出错误提示
            if (qualificationRtn) {
              // 跳转到中标候选人信息
              this.stepsActive = 1;
              // 重置表单配置
              this.formConfigList = this.stepsList[1].formList;
              // 错误提示
              this.$alert(
                "证书编号为空，请填写证书名称与证书编号！",
                "warning"
              );
              return;
            }
          }
        }
        // 中标名次加入集合
        arr.push(item.winningRanking);
        // 判断名字没有第一名的情况
        if (item.winningRanking == 1) {
          rankOne = true;
          this.winBasicInfoId += ";" + item.basicInfoId + ";,";
        }
      });
      // 弹出错误提示 直接return，避免下面的额外弹出消息
      if (winRtn) {
        return;
      }
      // 弹出错误提示 直接return，避免下面的额外弹出消息
      if (qualificationRtn) {
        return;
      }
      // 判断名词重复
      var rank = this.fun_ArrRepeat(arr);
      // 如果没第一名则弹出提示
      if (
        !rankOne &&
        this.form.evaluationMethod !== "202204061014580094" &&
        this.form.evaluationMethod !== "tenderFile,gcjsxmpdfl,pdflwys"
      ) {
        // 跳转到中标候选人信息
        this.stepsActive = 1;
        // 重置表单配置
        this.formConfigList = this.stepsList[1].formList;
        // 错误提示
        this.$alert("中标候选人中没设置第一名，请修改后再提交！", "warning");
        return;
      }
      // 如果重复则弹出提示
      if (
        !rank &&
        this.form.evaluationMethod !== "202204061014580094" &&
        this.form.evaluationMethod !== "tenderFile,gcjsxmpdfl,pdflwys"
      ) {
        // 跳转到中标候选人信息
        this.stepsActive = 1;
        // 重置表单配置
        this.formConfigList = this.stepsList[1].formList;
        // 错误提示
        this.$alert("中标候选人中标名次存在重复，请修改后再提交！", "warning");
        return;
      }
      // 赋值
      this.tenderNum = tenderNum;
      // 判断第一名是否为退还至招标人单位
      var winRefundFlag = false;
      // 添加退还招标人信息，但未选择单位
      var tenderFlag = false;
      //  判断中标候选人是否录入退还招标单位保证金信息
      var basicInfoIdFlag = false;
      // 该项目是否存在保证金信息
      if (this.form.tenderBondFlag === "1") {
        // 遍历
        this.refundFormObj.tableData.map(item => {
          // 投标单位选择
          if (!item.refundCorpId) {
            // 赋值
            tenderFlag = true;
            // 拼接退还编号
            this.accountBasicInfoId += item.refundCorpId + ",";
          }
          // 判断第一名是否为退还至招标人的单位信息
          if (this.winBasicInfoId.indexOf(item.refundCorpId) > 0) {
            // 赋值
            winRefundFlag = true;
          }
          // 遍历中标候选人信息
          this.formObj.tableData.map(element => {
            // 判断中标候选人是否录入退还招标单位保证金信息
            if (item.refundCorpId === element.basicInfoId) {
              basicInfoIdFlag = true;
            }
          });
        });
        // 是否有选中第一名
        if (winRefundFlag) {
          // 跳转到中标候选人信息
          this.stepsActive = 1;
          // 重置表单配置
          this.formConfigList = this.stepsList[1].formList;
          this.$alert(
            "退还至招标人的投标单位退还信息中，存在中标候选人是第一名的单位，请修改后再提交！",
            "warning"
          );
          return;
        }
        // 添加退还招标人单位，是否有选中投标单位
        if (tenderFlag) {
          // 跳转到中标候选人信息
          this.stepsActive = 1;
          // 重置表单配置
          this.formConfigList = this.stepsList[1].formList;
          this.$alert(
            "你添加退还至招标人的投标单位信息，但未选择具体的投标单位，请修改后再提交！",
            "warning"
          );
          return;
        }
        // 判断中标候选人是否录入退还招标单位保证金信息
        if (basicInfoIdFlag) {
          // 跳转到中标候选人信息
          this.stepsActive = 1;
          // 重置表单配置
          this.formConfigList = this.stepsList[1].formList;
          this.$alert(
            "你添加退还至招标人的投标单位信息，存在中标候选人的单位，请修改后再提交！",
            "warning"
          );
          return;
        }
      }
      // 操作成功
      if (rtn) {
        // 项目经理效验是否与报名一致
        this.fun_CheckManagerValidation(state, winCandidates, unionInfo);
      } else {
        // 校验
        this.fun_managerOnline(state, winCandidates, unionInfo);
      }
    },
    /**
     * 判断数组重复
     * @author shuhua
     */
    fun_ArrRepeat(arr) {
      // 声明重复数据
      var rtn = true;
      var s = arr.join(",") + ",";
      // 循环数组比较重复项
      for (var i = 0; i < arr.length; i++) {
        // 比较重复值
        if (s.replace(arr[i] + ",", "").indexOf(arr[i] + ",") > -1) {
          rtn = false;
          break;
        }
      }
      return rtn;
    },
    /**
     * 项目经理效验是否与报名一致
     * @author shuhua
     */
    fun_CheckManagerValidation(state, winCandidates, unionInfo) {
      // 发起请求
      fun_PostAction("/winningPublicity/checkManagerValidation", {
        tenderReference: this.form.tenderReference,
        winCandidates: JSON.stringify(winCandidates)
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 校验
          this.fun_managerOnline(state, winCandidates, unionInfo);
        } else {
          // 错误消息
          this.$message.error(msg);
        }
      });
    },
    /**
     * 校验
     */
    fun_managerOnline(state, winCandidates, unionInfo) {
      // 中标候选人为空
      if (this.formObj.tableData.length === 0) {
        // 跳转到中标候选人信息
        this.stepsActive = 1;
        // 重置表单配置
        this.formConfigList = this.stepsList[1].formList;
        // 错误提示
        this.$alert("中标候选人不能为空！", "warning");
        return;
      }
      // 设置状态
      this.form.state = state;
      // 获取投资总额
      var totalInvestment = Number(this.form.totalInvestment);
      // 判断中标价格是否大于投资总额
      let flag = true;
      // 如果公示状态不是撤回
      if (this.form.publicState != "2") {
        // 遍历
        this.formObj.tableData.map(item => {
          // 投资总额不为空
          if (totalInvestment && totalInvestment != "0") {
            // 中标价转为数字
            var winningPrice = Number(item.winningPrice);
            // 如果中标价格大于投资总额
            if (totalInvestment < winningPrice) {
              flag = false;
            }
          }
        });
      }
      if (!flag) {
        this.$confirm(
          "您录入的候选人信息中存在投标报价大于投资总额" +
            '<a style="color: red;">' +
            totalInvestment +
            "（万元）</a>" +
            "的数据，是否依然进行提交操作？",
          "提示",
          {
            dangerouslyUseHTMLString: true,
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        ).then(() => {
          // 项目经理与单位检查
          this.fun_CheckCorpWork(winCandidates);
        });
      } else {
        // 项目经理与单位检查
        this.fun_CheckCorpWork(winCandidates);
      }
    },
    /**
     * 项目经理与单位检查
     * @author shuhua
     */
    fun_CheckCorpWork(winCandidates) {
      // 发起请求
      fun_PostAction("/winningPublicity/checkCorpWork", {
        tenderReference: this.form.tenderReference,
        winCandidates: JSON.stringify(winCandidates),
        tenderContentNum: this.form.tenderContentNum,
        unionFlag: this.unionFlag,
        ebsFlag: this.form.ebsFlag,
        isNeedPm: this.form.isNeedPm
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 存在保证金退还信息
          if (this.form.tenderBondFlag === "1") {
            // 检查投标单位基本户
            this.fun_CheckBasicAccount();
          } else {
            // 调用弹框
            this.fun_CaLock();
          }
        } else {
          // 核验通过并且公告状态为正常时
          if (this.updatePublicState === "0") {
            // 调用弹框
            this.fun_CaLock();
          } else {
            // 错误提示
            this.$message.error(msg);
          }
        }
      });
    },
    /**
     * 检查投标单位基本户
     * @author shuhua
     */
    fun_CheckBasicAccount() {
      // 发起请求
      fun_PostAction("/winningPublicity/checkBasicAccount", {
        tenderReference: this.form.tenderReference,
        winBasicInfoId: this.winBasicInfoId,
        refundCorpIds: this.accountBasicInfoId,
        basicInfoIds: "",
        flag: "0"
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 提示消息不为空
          if (data.msg != "" && data.msg != null) {
            // 询问框
            this.$confirm(data.msg, "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            }).then(() => {
              // 调用弹框
              this.fun_CaLock();
            });
          }
          // 提示消息为空
          else {
            // 调用弹框
            this.fun_CaLock();
          }
        } else {
          // 核验通过并且公告状态为正常时
          if (this.updatePublicState === "0") {
            // 调用弹框
            this.fun_CaLock();
          } else {
            // 错误提示
            this.$message.error(msg);
          }
        }
      });
    },
    /**
     * 验证表单
     * @param {*} i tabs切换
     */
    fun_val(i, state) {
      // 验证第一个表单
      this.$refs.collapseForm.$refs.enInform.validate(valid => {
        if (valid) {
          // 最后一个表单
          if (i === this.stepsList.length - 1) {
            // 登记中的招标范围与招标范围不为空
            if (
              this.form.regTenderContent != "" &&
              this.form.regTenderContent != null &&
              this.form.tenderScope != "" &&
              this.form.tenderScope != null
            ) {
              // 登记中的招标范围不等于招标范围
              if (this.form.regTenderContent != this.form.tenderScope) {
                // 招标范围修改原因为空
                if (!this.form.tenderScopeUpdate) {
                  // 跳转到中标项目基本信息
                  this.stepsActive = 0;
                  // 重置表单配置
                  this.formConfigList = this.stepsList[0].formList;
                  // 设置招标范围修改原因为可编辑
                  this.fun_ScopeUpdate(false);
                  // 错误提示
                  this.$alert(
                    "已修改招标范围内容，请填写招标范围修改原因！",
                    "warning"
                  );
                  return;
                }
              }
            }
            // 开标地点或开标时间为空
            if (!this.form.bidOpeningAddress || !this.form.bidOpeningTime) {
              // 跳转到开标记录信息
              this.stepsActive = 2;
              // 重置表单配置
              this.formConfigList = this.stepsList[2].formList;
              // 错误提示
              this.$alert(
                "开标记录不能为空，请在开标模块中填写开标记录信息，才能录入中标候选人信息！",
                "warning"
              );
              return;
            }
            // 公示天数小于3
            if (Number(this.form.publicityDay) < 3) {
              // 跳转到中标项目基本信息
              this.stepsActive = 0;
              // 重置表单配置
              this.formConfigList = this.stepsList[0].formList;
              // 错误提示
              this.$alert("公示天数不得少于3天！", "warning");
              return;
            }
            // 效验项目负责人与报名是否一致
            this.fun_ManagerValidation(state);
          } else {
            this.formConfigList = this.stepsList[i + 1].formList;
            this.$nextTick(() => {
              // 递归验证表单
              this.fun_val(i + 1, state);
            });
          }
        } else {
          // 定位到未填表单
          this.stepsActive = i;
          // 提示
          this.$alert("页面存在错误信息，请检查后重试！", "warning");
          return false;
        }
      });
    },
    // 调用弹框
    fun_CaLock() {
      // 表单位置赋值
      this.stepsActive = this.stepsList.length - 1;
      // 如果是提交
      if (this.form.state == "tj") {
        // 开启弹窗
        this.$refs.caLock.dialogCalock = true;
        // 签名数据, 交易人名称和日期
        this.$refs.caLock.data =
          this.form.state +
          this.form.prjName +
          this.form.tenderReference +
          this.form.publicityStartDate +
          this.form.publicityEndDate;
        // 状态
        this.$refs.caLock.state = this.form.state;
      } else {
        // 提交的方法
        this.fun_Submit("bc", "0");
      }
    },
    /**
     * 保存或修改的方法
     * @author shuhua
     */
    fun_SaveOrUpdate(state, lockNo, digitalSignature) {
      // ca弹窗关闭
      this.$refs.caLock.dialogCalock = false;
      // 赋值锁编号
      this.form.lockNo = lockNo;
      // 赋值数字签名
      this.form.digitalSignature = digitalSignature;
      // 操作状态
      this.form.state = state;
      // 不为空
      if (this.title != "" && this.title != null) {
        // 招标人提交
        this.fun_TenderStampSubmit();
      } else {
        // 提交的方法
        this.fun_Submit();
      }
    },

    /**
     * 提交的方法
     * @author shuhua
     */
    fun_Submit(state, flag) {
      // 如果是保存
      if (state == "bc" && !this.form.prjName) {
        // 错误提示
        this.$alert("请优先选择中标项目信息！", "warning");
        return false;
      }
      // 如果不为空
      if (state) {
        // 操作状态
        this.form.state = state;
        // 设置投标人集合
        this.fun_SetTenderNum();
      }
      // 表单
      var formData = new FormData();
      // 中标公示信息
      formData.append("winningPublicity", JSON.stringify(this.form));
      // 公示状态
      formData.append("updatePublicState", this.updatePublicState);
      // 保证金退还信息
      formData.append("refundList", JSON.stringify(this.refundFormObj.tableData));
      // 上传附件不为空
      if (this.fileChangeList.length > 0) {
        // 退还保证金附件
        formData.append("refundFile", this.fileChangeList[0].raw);
      }
      // 操作标志
      formData.append("controllerFlg", this.controllerFlg);
      // 中标候选人信息
      formData.append("list", JSON.stringify(this.formObj.tableData));
      // 投标人
      formData.append("tenderNum", this.tenderNum);
      // 加载框
      this.fun_Loading();
      // 发起请求
      fun_UploadImg("/winningPublicity/saveOrUpdate", formData, 0).then(res => {
        // 解构res.data
        const { result, msg, data } = res.data;
        // 操作成功
        if (result) {
          // 返回id
          this.id = data.id;
          // 关闭遮罩
          this.fullLoading.close();
          // 判断是保存
          if (state === "bc" && flag) {
            // 修改状态
            this.controllerFlg = "update";
            // 请求详情
            this.fun_Details();
            // 文件集合为空
            this.fileChangeList = [];
            return;
          }
          // 操作成功
          this.$message.success(msg);
          // 返回一览
          this.$router.back();
        } else {
          // 如果提示消息时
          if (msg == "撤回中标公示，需上传附件！") {
            // 跳转到中标项目基本信息
            this.stepsActive = 0;
            // 获取表单数据
            this.formConfigList = this.stepsList[this.stepsActive].formList;
          }
          // 关闭遮罩
          this.fullLoading.close();
          // 错误消息提示
          this.$message.error(msg);
        }
      });
    },

    /**
     * 甲方确认
     */
    fun_GetTenderSignature(data) {
      this.form.tenderOpinion = data.data.tenderOpinion; // 招标人意见
      this.tenderSignedForm.table = data.data.tableName; // 表名
      this.tenderSignedForm.key = data.data.keyState; // 字段
      this.tenderSignedForm.recordNumber = data.data.id; // 数据编号
      this.tenderSignedForm.tenderOpinion = data.tenderOpinion; // 招标人意见
      this.tenderSignedForm.tenderSignedId = data.tenderSignedId; // 招标人签章确认编号
      this.tenderSignedForm.tenderSignedState = data.tenderSignedState; // 招标人签章状态
      this.tenderSignedForm.isDeregulation = data.isDeregulation; // 添加标记
      this.tenderSignedForm.esRegulators = data.esRegulators; // 招标人盖章确认的招标监管部门
      this.tenderSignedForm.esProcessType = data.esProcessType; // 招标人盖章确认的招标监管流程
      this.tenderSignedForm.esInvitationId = data.esInvitationId; // 招标人盖章确认权限编号
      this.tenderSignedForm.tenderStampData = data.tenderStampData; // 招标人盖章的数字签名
    },

    /**
     * 甲方确认提交与退还
     */
    fun_TenderStamp(e) {
      // 如果招标人意见不为空
      if (this.form.tenderOpinion != "" && this.form.tenderOpinion != null) {
        // 设置招标人意见
        this.tenderSignedForm.tenderOpinion = this.form.tenderOpinion;
      }
      // 开启弹窗
      this.$refs.caLock.dialogCalock = true;
      // 签名数据, 交易人名称和日期
      this.$refs.caLock.data = this.form.id + this.form.tenderPrjName;
      // 状态
      this.$refs.caLock.state = e;
      this.$refs.caLock.tenderSigned = e;
      this.$refs.caLock.tenderSignedForm = this.tenderSignedForm;
    },

    /**
     * 外商投资列表勾选事件
     * @author shuhua
     */
    fun_HandleSelectionChange(e) {
      // 赋值勾选数组
      this.multipleSelection = e;
    },

    /**
     * 外商投资列表勾选事件
     * @author shuhua
     */
    fun_RefundSelectionChange(e) {
      // 赋值勾选数组
      this.refundMultipleSelection = e;
    },

    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取保证金退还信息
      this.fun_RefundBidBondList();
    },

    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取保证金退还信息
      this.fun_RefundBidBondList();
    },

    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_TenderLimitChange() {
      // 获取每页显示条数
      this.tenderReqPageData.size = e;
      // 获取中标候选人选择一览
      this.fun_GetPrjTenderList();
    },

    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_TenderPageChange() {
      // 获取当前页码
      this.tenderReqPageData.current = e;
      // 获取中标候选人选择一览
      this.fun_GetPrjTenderList();
    },
    /**
     * 查询
     */
    fun_TenderSearch() {
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetPrjTenderList();
    },
    /**
     * 重置
     * @author 滕威
     */
    fun_TenderReset() {
      // 清除查询表单
      this.$refs.list.$refs.formItem.map(e => {
        e.resetField();
      });
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetPrjTenderList();
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_PictureLimitChange(e) {
      // 获取每页显示条数
      this.picturePageData.size = e;
      // 获取一览表格数据
      this.fun_MyFileList();
    },

    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PicturePageChange(e) {
      // 获取当前页码
      this.picturePageData.current = e;
      // 获取一览表格数据
      this.fun_MyFileList();
    },

    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_RevocationLimitChange(e) {
      // 获取每页显示条数
      this.revocationPageData.size = e;
      // 获取一览表格数据
      this.fun_MyFileList();
    },

    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_RevocationPageChange(e) {
      // 获取当前页码
      this.revocationPageData.current = e;
      // 获取一览表格数据
      this.fun_MyFileList();
    },

    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_RefundLimitChange(e) {
      // 获取每页显示条数
      this.refundReqPageData.size = e;
      // 获取一览表格数据
      this.fun_WinningRefundSelectList();
    },

    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_RefundPageChange(e) {
      // 获取当前页码
      this.refundReqPageData.current = e;
      // 获取一览表格数据
      this.fun_WinningRefundSelectList();
    },

    /**
     * 保证金查询
     */
    fun_RefundSearch() {
      // 重置分页
      this.refundReqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_WinningRefundSelectList();
    },

    /**
     * 获取文件模板路径
     * @author shuhua
     */
    fun_GetFileUrl() {
      // 发起请求
      fun_GetAction("/clientFileInfo/getAutomaticallyUpdateFiles", {
        number: 2,
        appName: "不退还申请表"
      }).then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 操作成功
        if (result) {
          // 不退还申请表路径
          this.url = data;
        }
      });
    },
    /**
     * 悬浮显示
     */
    inputOnMouseOver(event) {
      const target = event.target;
      // 判断是否开启tooltip功能
      if (target.offsetWidth < target.scrollWidth) {
        this.isShowTooltip = false;
      } else {
        this.isShowTooltip = true;
      }
    },
    /**
     * 返回的方法
     * @author shuhua
     */
    fun_Back() {
      // 返回
      this.$router.back();
    },
    /**
     * 全局加载
     * @author zhouzhou
     */
    fun_Loading() {
      // 全局加载
      this.fullLoading = Loading.service({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.6)"
      });
    },
    /**
     * 上一步
     */
    fun_GetLastStep() {
      // 如果不是详情
      if (this.controllerFlg != "detail") {
        // 公告状态不是撤回并且状态不是通过
        if (this.form.publicState != "2" && this.form.state != "tg") {
          // 如果是保存
          if (!this.form.prjName) {
            // 错误提示
            this.$alert("请优先选择中标项目信息！", "warning");
            return false;
          }
          // 提交的方法
          this.fun_Submit("bc", "0");
        }
      }
      // 是否填写当前表单
      if (this.fun_GetStepsIsData()) {
        // 设置当前流程已保存
        this.stepsList[this.stepsActive].isSave = true;
      }
      // 如果中标候选人信息列表有数据
      if (this.formObj.tableData && this.formObj.tableData.length > 0) {
        // 设置保存状态
        this.stepsList[1].isSave = true;
      }

      // 减1
      this.stepsActive--;
      // 获取表单数据
      this.formConfigList = this.stepsList[this.stepsActive].formList;
    },
    /**
     * 下一步
     */
    fun_GetNextStep() {
      // 如果不是详情
      if (this.controllerFlg != "detail") {
        // 公告状态不是撤回并且状态不是通过
        if (this.form.publicState != "2" && this.form.state != "tg") {
          // 如果是保存
          if (!this.form.prjName) {
            // 错误提示
            this.$alert("请优先选择中标项目信息！", "warning");
            return false;
          }
          // 提交的方法
          this.fun_Submit("bc", "0");
        }
        // 是否填写当前表单
        if (this.fun_GetStepsIsData()) {
          // 设置当前流程已保存
          this.stepsList[this.stepsActive].isSave = true;
        }
        // 如果中标候选人信息列表有数据
        if (this.formObj.tableData && this.formObj.tableData.length > 0) {
          // 设置保存状态
          this.stepsList[1].isSave = true;
        }
        // 加1
        this.stepsActive++;
        // 设置下一个流程可点击
        this.stepsList[this.stepsActive].isActive = true;
        // 获取表单数据
        this.formConfigList = this.stepsList[this.stepsActive].formList;
      }
      // 如果是详情页面
      else {
        // 设置当前流程已保存
        this.stepsList[this.stepsActive].isSave = true;
        // 加1
        this.stepsActive++;
        // 设置下一个流程可点击
        this.stepsList[this.stepsActive].isActive = true;
        // 获取表单数据
        this.formConfigList = this.stepsList[this.stepsActive].formList;
      }
    },
    /**
     * 监听滚动
     */
    fun_HandleScroll(e) {
      // 判断
      if (e.target.offsetTop < this.$refs.sticky.offsetTop) {
        // 添加样式
        this.$refs.sticky.style.boxShadow = "0 0 8px 3px rgba(0, 0, 0, 0.06)";
      } else {
        // 添加样式
        this.$refs.sticky.style.boxShadow = "none";
      }
    },
    /**
     * 点击流程
     */
    fun_GetClickSteps(val, index) {
      // 判断是否可点击
      if (val.isActive) {
        // 如果不是详情
        if (this.controllerFlg != "detail") {
          // 公告状态不是撤回并且状态不是通过
          if (this.form.publicState != "2" && this.form.state != "tg") {
            // 如果是保存
            if (!this.form.prjName) {
              // 错误提示
              this.$alert("请优先选择中标项目信息！", "warning");
              return false;
            }
            // 提交的方法
            this.fun_Submit("bc", "0");
          }
        }
        // 是否填写当前表单
        if (this.fun_GetStepsIsData()) {
          // 设置当前流程已保存
          this.stepsList[this.stepsActive].isSave = true;
        }
        // 如果中标候选人信息列表有数据
        if (this.formObj.tableData && this.formObj.tableData.length > 0) {
          // 设置保存状态
          this.stepsList[1].isSave = true;
        }
        // 赋值下标
        this.stepsActive = index;
        // 获取表单数据
        this.formConfigList = val.formList;
      }
    },
    /**
     * 查看撤回备份详情
     */
    fun_LookDetails(e) {
      // 打开弹窗
      this.$refs.winningPublicBackupDetail.dialogVisible = true;
      // 备份主键
      this.$refs.winningPublicBackupDetail.id = e.val.id;
      // 中标公示编号
      this.$refs.winningPublicBackupDetail.publicityNumber =
        e.val.winningPublicityId;
      // 获取详情
      this.$refs.winningPublicBackupDetail.fun_Details();
    },
    /**
     * 初始化时处理流程判断表单是否填写内容
     */
    fun_GetInitializeStepsIsData() {
      // 遍历流程数据
      this.stepsList.map((item, index) => {
        // 遍历表单内容
        item.formList.map(formList => {
          // 遍历表单字段
          formList.formConfigList.map(form => {
            // 判断是否填写内容
            if (this.form[form.value]) {
              // 改变状态
              item.isSave = true;
            }
          });
        });
      });
    },
    /**
     * 用于判断当前流程是否填写数据
     */
    fun_GetStepsIsData() {
      // 声明
      var formArr = []; // 所有表单
      var isFormKey = false; // 是否填写
      // 遍历获取所有表单数据
      this.formConfigList.map(item => {
        // 判断是否存在表单
        if (item.formConfigList && item.formConfigList.length > 0)
          formArr.push(...item.formConfigList);
      });
      // 判断当前表单
      for (var i = 0; i < formArr.length; i++) {
        // 判断字段是否填写值
        if (this.form[formArr[i].value]) {
          // 改变标识
          isFormKey = true;
          // 跳出循环
          break;
        }
      }
      return isFormKey;
    },
    /**
     * 设置投标人集合数据
     */
    fun_SetTenderNum() {
      // 用于存储国家代码
      var tenderNum = "";
      // 遍历
      this.formObj.tableData.forEach(item => {
        // 中标候选人名称							// 招标人名称			// 中标候选人编号						// 是否联合体			// 是否联合体主体					// 组织机构代码
        var key =
          item.basicInfoId +
          ";" +
          item.corpName +
          ";" +
          item.basicInfoId +
          ";" +
          item.unionAgreementId +
          ";" +
          item.tenderUnitsNotMainName +
          ";" +
          item.basicInfoCode;
        // 拼接
        tenderNum = key + "!" + tenderNum;
      });
      // 赋值
      this.tenderNum = tenderNum;
    },

    /**
     * 弹出框的方法
     * @author rsj
     */
    fun_Dialog(e) {
      // 打开弹窗
      this.$refs.printDialog.dialogVisible = true;
      // ids
      this.$refs.printDialog.basicInfoId = e.basicInfoId;
    },

    /**
     * 查看资料
     * @author rsj
     */
    fun_FileLook(e,basicInfoId) {
      //
      if(e == "1"){
        // 设置资格预审形式
        this.$refs.fileLookDialog.prequalificationType = '1';
        // 文件类型
        this.$refs.fileLookDialog.fileType = '4';
      }else{
        // 设置资格预审形式
        this.$refs.fileLookDialog.prequalificationType = '2';
        // 文件类型
        this.$refs.fileLookDialog.fileType = '1';
      }
      // 设置招标编号
      this.$refs.fileLookDialog.projectId = this.form.tenderReference;
      // 用户编号
      this.$refs.fileLookDialog.tbUserId = basicInfoId;
      // 打开弹窗
      this.$refs.fileLookDialog.dialogVisible = true;
      // 查询投标人数据
      this.$refs.fileLookDialog.fun_GetBidderList();
      // 查询文件数据
      this.$refs.fileLookDialog.fun_GetList();
    },

    /**
     * 查看资料
     * @author rsj
     */
    fun_AuditFileLook() {
      // 发起请求
      fun_PostAction("/winningPublicity/getEvaluationPublicityZip", {
        tenderReference: this.form.tenderReference
      }).then(res => {
        // 结构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 设置招标编号
          this.$refs.evaluationPublicity.projectId = this.form.tenderReference;
          // 设置资格预审标志
          this.$refs.evaluationPublicity.prequalificationType = this.prequalificationType;
          // 打开弹窗
          this.$refs.evaluationPublicity.dialogVisible = true;
          // 查询文件数据
          this.$refs.evaluationPublicity.fun_GetList();
        } else {
          this.$alert(msg, "warning");
          return;
        }
      });
    },
  }
}